import { useEffect, useState } from 'react';
import { OnboardingEye } from '../../onboarding/Eye';
import BPContainer from '../../BionicUI/container/BPContainer';
import BPButton from '../../BionicUI/button/BPButton';
import BPIcon from '../../BionicUI/icons/BPIcon';
import BPInput from 'components/BionicUI/input/BPInput';
import { useAuth } from 'context/auth.context';
import { SequenceItem } from '../../onboarding/kyc/OnboardingKYCSequence';
import BPInstruction from '../../BionicUI/instruction/BPInstruction';
import { checkIsEmailValid } from 'utils/validation';
import { useNavigate } from 'react-router-dom';
// import useLoginStore from 'stores/loginStore';
import { MAP_ONBOARDING_PHASE_TO_ROUTE } from 'utils';
import { FirebaseError } from 'firebase/app';
import BPToast from 'components/BionicUI/toast/BPToast';
import useNotifyStore from 'stores/notifyStore';
import { OnboardingPhases } from 'core/models/users/user.model';
import useOnboardingStore from 'stores/onboardingStore';
import InputBar from 'components/onboarding/InputBar';
import { usePrivy } from '@privy-io/react-auth';
import BPLinkButton from 'components/BionicUI/linkButton/BPLinkButton';
import { ROUTES } from 'routes';

const ChooseLoginMethod = () => {
  const { handleProfileCreationOrLoad } = useAuth();
  const [showInputBar, setShowInputBar] = useState<boolean>(false);
  const [showEmailInput, setShowEmailInput] = useState<boolean>(false);
  // const { nextStep, setEmail } = useLoginStore();
  const [showEmailInputIntro, setShowEmailInputIntro] =
    useState<boolean>(false);
  const { setCurrentToast } = useNotifyStore();
  const navigate = useNavigate();
  const { setProgressStep } = useOnboardingStore();
  const { login, logout, user, authenticated } = usePrivy();

  async function handleSignIn(methods: ['google'] | ['email']) {
    setShowEmailInputIntro(false);
    try {
      // await signInWithGoogle();
      if (user && authenticated) {
        logout();
        // localStorage.removeItem('smartWallet');
      } else {
        login({ loginMethods: methods });
      }
    } catch (error) {
      const errMsg = (error as FirebaseError).message || 'Try Again Later.';

      setCurrentToast(<BPToast message={errMsg} variant="error" />);
    }
  }

  useEffect(() => {
    if (user && authenticated) {
      getToken();
    }
  }, [user, authenticated]);

  const getToken = async () => {
    try {
      const response = await handleProfileCreationOrLoad();
      if (!!response) {
        if (response.onboardingPhase === OnboardingPhases.SIGNUP) {
          setProgressStep(2);
        }
        if (
          response.roles?.includes('PROJECT_OWNER') &&
          response.onboardingPhase === OnboardingPhases.DONE
        ) {
          navigate(ROUTES.APPLICATION_IN_REVIEW);
        } else {
          navigate(MAP_ONBOARDING_PHASE_TO_ROUTE[response.onboardingPhase]);
        }
      }
      // return token;
    } catch (error) {
      console.log('Error in login--', error);
      logout();
    }
  };

  const handleSignup = () => {
    navigate(ROUTES.ONBOARDING);
  };

  return (
    <SequenceItem>
      <div className="inline-grid relative w-full max-w-[800px] px-6 grid-cols-[auto_1fr] gap-[20px] mx-auto pt-[15vh] items-start">
        <OnboardingEye zoomDown />
        {showEmailInputIntro ? (
          <BPInstruction
            key={'email_input_intro'}
            line1={{
              text: 'Enter your email address...',
              sound: 'kyc/please-enter-your-email-address_1.mp3',
            }}
            onAnimComplete={() => {
              setShowInputBar(true);
              setShowEmailInput(true);
            }}
          />
        ) : (
          <BPInstruction
            key={'ChooseLoginMethod_intro'}
            line1={{
              text: 'Please log in to continue...',
              sound: 'kyc/please-log-in-to-continue_1.mp3',
            }}
            onAnimComplete={() => setShowInputBar(true)}
          />
        )}
      </div>
      {showInputBar && (
        <>
          {showEmailInput ? (
            <InputBar
              fadeUp
              showBackButton
              onClickBackButton={() => window.location.reload()}
              key={'enter_your_email_address'}
            >
              <BPInput
                state="default"
                type="email"
                placeholder="Enter your email address"
                button={{
                  state: 'primary',
                  onClick: () => {
                    // setEmail(String(inputText));
                    // nextStep();
                  },
                  title: 'Submit',
                }}
                validate={(email) => checkIsEmailValid(email)}
              />
            </InputBar>
          ) : (
            <>
              {/* <p className="text-base w-full">
                If you want to join as a project owner, then log in with Google
              </p> */}
              <InputBar fadeUp showBackButton={false}>
                <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
                  <BPButton
                    state="glass"
                    onClick={() => {
                      handleSignIn(['email']);
                      // setShowInputBar(false);
                      // setShowEmailInputIntro(true);
                    }}
                  >
                    <BPIcon icon="mail" className="fill-white" />{' '}
                    {user && authenticated ? 'Logout' : 'Log in with Email'}
                  </BPButton>
                  <BPButton
                    state="glass"
                    onClick={() => handleSignIn(['google'])}
                  >
                    <BPIcon icon="google" /> Log in with Google
                  </BPButton>
                </BPContainer>

                <div className="block relative w-full justify-center mt-4">
                  <BPLinkButton className="mx-auto" onClick={handleSignup}>
                    Not a member yet? Sign up
                  </BPLinkButton>
                </div>
              </InputBar>
            </>
          )}
        </>
      )}
    </SequenceItem>
  );
};

export default ChooseLoginMethod;
